import React from "react";
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/ext-language_tools";
import { FormLabel } from "carbon-components-react";
import "./AceEditor.scss"

const Editor = ({ value, onChange, name, labelText, invalidText, theme = "github", mode = "json", dangerMessage = null, height }) => {
    let errorText = null

    if (typeof invalidText === "string") {
        errorText = <div><small>{invalidText}</small></div>
    }
    else if (Array.isArray(invalidText)) {
        errorText = invalidText?.map(errorText => <div><small>{errorText}</small></div>)
    }
    return (
        <div>
            <FormLabel>
                {labelText}
            </FormLabel>
            {
                errorText && (
                    <div className="form-error__text" style={{ marginBottom: "1rem" }}>
                        {errorText}
                    </div>
                )
            }
            {
                dangerMessage && (
                    <div className="ace-editor__danger-zone">
                        <span className="ace-editor__danger-zone--text">{dangerMessage}</span>
                    </div>
                )
            }
            <AceEditor
                mode={mode}
                theme={theme}
                width="auto"
                height={height}
                onChange={onChange}
                name={name}
                value={value}
                editorProps={{ $blockScrolling: true }}
                setOptions={{
                    enableBasicAutocompletion: true,
                    enableLiveAutocompletion: true,
                    enableSnippets: true
                }}
            />
        </div>
    );
}

export default Editor